export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-4 md:pb-6 border-b border-zinc-200">
      <div>
        {eyebrow && (
          <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tighter font-black text-zinc-950 break-words">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-zinc-600 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
